import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconEdit: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 24 24">
    <path
      fill="#332E69"
      fillRule="evenodd"
      d="M13.727 1.358a2.6 2.6 0 00-3.677 0L2.986 8.422a2.6 2.6 0 00-.631 1.027L.429 15.313a.6.6 0 00.758.757l5.863-1.925a2.6 2.6 0 001.028-.632L15.14 6.45a2.6 2.6 0 000-3.677l-1.414-1.414zm-2.828.849a1.4 1.4 0 011.98 0l1.414 1.414a1.4 1.4 0 010 1.98l-.672.672-3.394-3.395.672-.671zM4.345 8.76l1.252.358a2.6 2.6 0 011.785 1.785l.358 1.251 5.033-5.033-3.394-3.394L4.345 8.76zm2.384 4.226l-.5-1.753a1.4 1.4 0 00-.962-.961L3.513 9.77a1.396 1.396 0 00-.018.053l-.908 2.763 1.325 1.325 2.764-.907.053-.019z"
      clipRule="evenodd"
    ></path>
  </Icon>
);
